/* eslint-disable react-hooks/exhaustive-deps */
import { ALIGN, defaultTimelineDots, ILanding, ILandingSection, ITimelineDot } from "src/modules/pe-landing-module/data/interfaces"
import { IDataComponentsProps } from "../DataComponents"
import { useEffect, useState } from "react"
import useLandingSize from "src/modules/pe-landing-module/hooks/useLandingSize"
import { useComposition } from "src/modules/pe-landing-module/hooks/useComposition"
import { HasId, WINDOW_WIDTH } from "src/libs/interfaces/layouts"
import { CSSObjectToString, getCssDemention, getID } from "src/libs/utilities"
import addCSSClass from "src/libs/layout-app/utils/addCSSClass"
import { setHorizontalAlignToCSSRule } from "../Section"
import removeCSSClass from "src/libs/layout-app/utils/removeCSSClass"
import { ILandingStore, useLandingStore } from "src/modules/pe-landing-module/data/store"
import { components } from "src/modules/pe-landing-module/data/utils/components"
import DataDummy from "../../landing-edit/DataDummy"
import VerticalTimelineTitle from "./VerticalTimelineTitle" 
import { HTML as _HTML } from "../../contentType"
import HorizontalTimelineDiagram from "../../contentType/cards/timeline/HorizontalTimelineDiagram"
import "../../../../assets/css/timeline.scss"
import { DataContentAnimateContainer } from "./DataContentAnimateContainer"
import { DataContentPositionContainer } from "./DataContentPositionContainer"

/* Protopia Ecosystem component */
export interface ISectionHorizontalTimelineProps extends IDataComponentsProps {
   
}
const SectionHorizontalTimeline = (props: ISectionHorizontalTimelineProps): JSX.Element => {
     const [section, setSection] = useState<ILandingSection>(props.section)  
    const sizes                 = useLandingSize()
    const composition           = useComposition( section )
    const is_two_side           = sizes.width >= WINDOW_WIDTH.TABLET && composition.columns > 1
    const [timelineId]          = useState<string>(getID("section"))
    const [current, setCurrent] = useState<number>( 0 )


    useEffect(() => {
        const dots =  props.section.dots || {} 
        const dot_stroke_width = dots.dot_stroke_width || 0
        const perimeter = (dots.perimeter || 0) + dot_stroke_width || 60  
        const fontSize  = dots.fontSize || 16
        const round     = getCssDemention( dots.radius )
        const color     = dots.color || "var(--force-contast-color)"
        const fontColor = dots.fontColor || "var(--force-contast-color)"

        addCSSClass(
            `section-vertical-timeline-container-${props.section.id}`,
            `.section-vertical-timeline-container-${props.section.id} {
                ${setHorizontalAlignToCSSRule(props.section.vertical_align || ALIGN.MIDDLE )};
                .landing-vertical-timeline-title-container {
                    ${ CSSObjectToString( dots?.title_style || {} ) }
                }
                .landing-v-timeline-container {
                    align-items: flex-start;
                }

                .landing-v-timeline-cards-${props.section.id}-left,
                .landing-v-timeline-cards-${props.section.id} { 
                    z-index:1; 
                }
                    
                .landing-v-timeline-cards-${props.section.id}-left {
                    margin-right : 0!important;
                    align-items: flex-end!important;
                }
                .h-timeline-dot {
                    width: ${perimeter}px!important;
                    height: ${perimeter}px!important;
                    font-size: ${fontSize}px!important;
                    background-color: ${ color }!important;
                    border-radius: ${ round }!important;
                    border-color: ${ dots.stroke || "var(--force-contrast-color)" };
                    border-style: solid;
                    border-width: ${ getCssDemention( dot_stroke_width ) };
                    color: ${ fontColor }!important;                   
                    top: 0;  
                    ${ CSSObjectToString( 
                        props.section.dots?.dot_style || 
                        {
                            backgroundColor: dots.color,
                            borderRadius: getCssDemention(dots.radius, "50%"),
                            borderWidth: getCssDemention( dots.stroke_width ),
                            borderStyle: "solid",
                            borderColor: `${dots.stroke}`
                        }, 
                        true
                    ) }
                    &.active {
                        ${ CSSObjectToString( props.section.dots?.active_dot_style || {}, true ) }
                    }
                    &:before {
                        content: "";
                        ${ CSSObjectToString( props.section.dots?.dot_before_style || {}, true  )};
                    }
                    &:after {
                        content: "";
                        ${ CSSObjectToString( props.section.dots?.dot_after_style || {}, true  )};
                    }
                }
            }
            `
        ) 
        return () => { 
            removeCSSClass( `section-vertical-timeline-container-${props.section.id}` )
        }
    }, [section])
    
    useEffect(() => { 
        const unsubscribe = useLandingStore.subscribe(
            ( state: ILandingStore ) => state.currentLanding,
            ( currentLanding:ILanding ) => { 
                const sec: ILandingSection = currentLanding.sections.find(s => s.id === props.section.id)!                            
                if( JSON.stringify( sec ) !== JSON.stringify( section ) ) { 
                    setSection(() => {
                        return sec
                    })
                }
            }, 
            {} 
        ) 
        return () => {
            unsubscribe(); 
        }
    }, [])

    const onCurrent = ( cur: number) => {
        setCurrent(cur)
    }

    return <div 
        className={ `landing-data-components-container landing-edit-cont ${section.className || ""} section-vertical-timeline-container-${props.section.id} pe-cards-container ` }  
        style={{...section.dstyle, gap: section.gap }} 
        data-proportia={composition.proportia.join(",")} 
    >
        <div className={`landing-h-timeline-container`} data-horizontal-timeline-id={timelineId}>
            <div className="container-fluid">  

                <HorizontalTimelineDiagram 
                    data={{
                        cards: [...section.data],
                        dots: section.dots || defaultTimelineDots() 
                    }}
                    section={section}
                    current={current}
                    onCurrent={onCurrent}
                />

                <div className="row"> 
                    {
                        props.data
                        .filter((data, i) => i >= current && i < current + 1 )
                        .map((data, i) => { 
                            if(data.isHidden) {
                                return <DataDummy key={ data.id } data={data} section={props.section} />
                            }
                            const type = data.type
                            const DataComponent = type && components()[ type ]
                                ?
                                components()[ type ].c
                                :
                                _HTML 
                            return <div className="landing-vertical-timeline-item col-md-12" key={ data.id } style={{ marginBottom: 25 }}> 
                                <DataContentAnimateContainer 
                                    {...props}
                                    i={ i }  
                                    proportia={ !!composition.proportia ? composition.proportia[i] : 100 / composition.columns }
                                    className={`landing-card-${ data.id }`} 
                                >
                                    <>
                                        <VerticalTimelineTitle card={ data } />
                                        <DataContentPositionContainer {...props} i={i} >
                                            <DataComponent  
                                                section={ section } 
                                                data={ { ...data, type } } 
                                            /> 
                                        </DataContentPositionContainer>
                                    </>
                                </DataContentAnimateContainer>
                            </div>
                        }) 
                    }
                </div> 
            </div>
        </div>
    </div>
}
export default SectionHorizontalTimeline
